define([
    "jquery",
    "components/modal",
    "core/urls",
    "core/iterate",
    'components/request-time-manager',
    "components/fake-progress",
    "core/utilities",
], function (
    $,
    modal,
    urls,
    iterate,
    requestTM,
    FakeProgress,
    utilities
) {
    var nodes = {
        modal: {
            modal: document.querySelector(".modal_js"),
            close: document.querySelector(".modal-close_js"),
            content: document.querySelector(".modal-content_js"),
            title: document.querySelector(".modal-title_js"),
            bg: document.querySelector(".modal-bg_js"),
            blur: [
                document.querySelector(".create-survey-review"),
                document.querySelector(".sidebar-nav"),
                document.querySelector(".navigation-top")
            ],
        },
        previewModal: document.querySelector(".modal-template-preview"),
        previewSurveyButton: document.querySelector(".preview-survey"),
        previewEmailButton: document.querySelector(".preview-email"),
        phaseStatusName: document.querySelector(".status-name"),
        phaseStatusNameDisplay: document.querySelector(".status-name-display"),
        triggerPhases: document.querySelector(".trigger.phases"),
        triggerProject: document.querySelector(".trigger.project"),
        projectChip: document.querySelector(".trigger.project .chip"),
        phaseChips: document.querySelectorAll(".trigger.phases .chip"),
        phaseText: document.querySelector(".trigger.phases .phase-text"),
        saveAlert: document.querySelector(".save-alert"),
        submit: document.querySelector("form .submit"),
        loaderElement: document.querySelector(".marketing-loader"),
        loaderHint: document.querySelector(".marketing-loader .loader-bar-wrap_hint"),
    };

    var createdModal = modal.create(nodes.modal, function (el) {});
    let modalTemplate = document.querySelector(".modal-template-leave_js");
    let hrefs = document.querySelectorAll("a[href]"); 
    let surveyId = document.querySelector("[data-survey-id]").dataset.surveyId;
    let dataTimeManager = new requestTM();

    let hrefsToIgnore = [
        urls['projects:start_projects_survey'](surveyId),
        urls['projects:start_projects_survey_s2'](surveyId),
        urls['projects:start_projects_survey_s3'](surveyId),
        urls['projects:start_projects_survey_s4'](surveyId),
    ];

    let loadingScreen = new FakeProgress(
        document.querySelector(".marketing-loader .loader-bar-wrap-bar")
    );

    function exitWarningGeneric() {
        iterate(hrefs, function (node) {
            node.addEventListener("click", (event) => {
                utilities.confirmPageExit(
                    event,
                    createdModal,
                    modalTemplate,
                    null,
                    hrefsToIgnore
                );
            });
        });
    }

    

    let showPreview = async (surveyId, type) => {
        let url = urls['projects:survey_preview'](surveyId);
        let title = `Survey Preview 
                        <a class='edit-link' href='${urls['projects:start_projects_survey_s3'](surveyId)}'>
                            Edit Survey
                        </a>`;

        if(type === "email") {
            url = urls['projects:email_preview'](surveyId);
            title = `Email Preview 
                        <a class='edit-link' href='${urls['projects:start_projects_survey_s2'](surveyId)}'>
                            Edit Email
                        </a>`;
        }

        await fetch(url, {
            method: "GET",
        })
        .then(async (response) => {
            let iframe = nodes.previewModal.querySelector('iframe');
            if(type === "email") {
                iframe.classList.add("no-events");
            } else {
                iframe.classList.remove("no-events");
            }
            iframe.srcdoc = await response.text();
        })
        .then(() => {
            createdModal.open({
                class: "survey-preview-modal",
                content: nodes.previewModal.innerHTML,
                title
            }, function (el) {});
        })
    }

    let createEventListeners = () => {
        nodes.previewSurveyButton.addEventListener("click", (event) => {
            event.preventDefault();
            showPreview(event.target.getAttribute("data-survey-id"), "survey");
        })

        nodes.previewEmailButton.addEventListener("click", (event) => {
            event.preventDefault();
            showPreview(event.target.getAttribute("data-survey-id"), "email");
        })

        nodes.saveAlert.addEventListener("click", () => {
            document.querySelector("button.submit").scrollIntoView({behavior: "smooth"});
        })

        nodes.submit.addEventListener("click", async (event) => {
            event.preventDefault();
            
            // get task ID
            await fetch(urls['projects:start_projects_survey_final'](surveyId), {
                method: "POST",
                body: new FormData(document.querySelector('form'))
            })
            .then(response => response.json())
            .then((data) => {
                dataTimeManager.start((error) => {
                    nodes.loaderElement.classList.add("disabled");
                    loadingScreen.loadFinish();
                });
        
                loadingScreen.reset();
                nodes.loaderElement.classList.remove("disabled");
                loadingScreen.startLoading(15);
        
                let request = async () => {
                    await fetch(urls['task_check'](data.task), {
                        method: "GET",
                    })
                    .then(response => response.json())
                    .then((data2) => {
                        if(data2.done) {
                            if(data2.successful) {
                                window.location = urls['projects:survey_manager']()
                            } else {
                                createdModal.open({
                                    class: "error-modal",
                                    content: "Something went wrong. Please try again.",
                                    title: "Error"
                                }, function (el) {
                                    loadingScreen.loadFinish();
                                    dataTimeManager.abort();
                                });
                            }
                        }
                    })
    
                };
                
                dataTimeManager.interval(request);
            })
        });
    }

    return {
        init: function () {
            nodes.submit.classList.remove("disabled", "loading");

            if(nodes.phaseChips.length) {
                let phaseStatus = nodes.phaseStatusName.innerText;
                nodes.phaseStatusNameDisplay.innerText = phaseStatus;

                if(nodes.phaseChips.length > 1) {
                    nodes.phaseText.innerHTML = '<span class="underline">phase statuses</span> are';
                }
            } else {
                if(nodes.triggerPhases) {
                    nodes.triggerPhases.classList.add("hide");
                }
            }

            // hide project section if it is empty
            if(!nodes.projectChip && nodes.triggerProject) {
                nodes.triggerProject.classList.add("hide");
            }

            createEventListeners();
            exitWarningGeneric();
        },
    };
});